import { render, staticRenderFns } from "./systemSetting.vue?vue&type=template&id=1787cca2&scoped=true"
import script from "./systemSetting.vue?vue&type=script&lang=js"
export * from "./systemSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1787cca2",
  null
  
)

export default component.exports